
import { makeStyles } from "@material-ui/styles";

export default makeStyles(() => ({
    chip: {
        margin: '5px 5px 5px 0',
        
    },
    subtitle: {
        display: 'flex', alignItems: 'center', marginTop: '10px' 
      },
      rating: {
        marginRight: "10px"
      }
}))